import React from 'react';
import { getScoringModeOptions } from '../routes/ScoringConfigUI';

const ScoringModeSelector = ({ value, onChange, threshold, onThresholdChange }) => {
  const modes = getScoringModeOptions();

  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Scoring Mode
        </label>
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="select-field w-full"
        >
          {modes.map((mode) => (
            <option key={mode.value} value={mode.value}>
              {mode.label}
            </option>
          ))}
        </select>
      </div>
      
      {value === 'PassFail' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Compliance Threshold (0-1)
          </label>
          <input
            type="number"
            min="0"
            max="1"
            step="0.1"
            value={threshold}
            onChange={(e) => onThresholdChange(parseFloat(e.target.value))}
            className="input-field w-full"
          />
          <p className="text-xs text-gray-500 mt-1">
            Minimum compliance score required to pass (e.g., 0.8 = 80%)
          </p>
        </div>
      )}
    </div>
  );
};

export default ScoringModeSelector;
